/* eslint-disable @typescript-eslint/no-require-imports */
// eslint-disable-next-line camelcase
import { applyMiddleware, configureStore, legacy_createStore } from '@reduxjs/toolkit'
import { createEpicMiddleware } from 'redux-observable'

import { USE_REDUX_TOOLS } from 'system'

import rootReducerCreator, { epics } from '../src/reducers'

import type { compose } from '@reduxjs/toolkit'

const epicMiddleWare = createEpicMiddleware()
const middlewares = [epicMiddleWare]

if (process.env.NODE_ENV === 'development') {
  // Adds the logger
  middlewares.push(
    require('redux-logger').createLogger({
      // collapse all
      collapsed: () => true,
    }),
  )
}

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose
  }
}

const store = USE_REDUX_TOOLS
  ? configureStore({
      devTools: process.env.NODE_ENV !== 'production',
      enhancers: [applyMiddleware(...middlewares)],
      reducer: rootReducerCreator(),
    })
  : legacy_createStore(
      rootReducerCreator(),
      {},
      /* istanbul ignore next */
      process.env.NODE_ENV === 'development' && window?.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
        ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__(applyMiddleware(...middlewares))
        : applyMiddleware(...middlewares),
    )

/* istanbul ignore next */
if (process.env.NODE_ENV === 'production') {
  epicMiddleWare.run(epics)
} else {
  const { BehaviorSubject, switchMap } = require('rxjs')
  const epic$ = new BehaviorSubject(epics)

  // Every time a new epic is given to epic$ it
  // will unsubscribe from the previous one then
  // call and subscribe to the new one because of
  // how switchMap works
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const hotReloadingEpic = (...args: any) => epic$.pipe(switchMap((epic: any) => epic(...args)))
  epicMiddleWare.run(hotReloadingEpic)

  // Enable Webpack hot module replacement for reducers
  // @ts-expect-error - module.hot is a webpack-specific property
  module?.hot?.accept('../src/reducers', () => {
    // Reducer replace
    const hotReducers = require('../src/reducers')
    // epicMiddleWare.replaceEpic(hotReducers.epics)
    epic$.next(hotReducers.epics)
  })
}

declare global {
  type GlobalState = ReturnType<typeof store.getState>
  type GlobalDispatch = typeof store.dispatch
}

export default store
